export default __webpack_public_path__ + "static/media/06.a23f7d11.jpg";